module.exports = __webpack_public_path__ + "img/deluxe-vehicle-search-filter-nissan.b2139c79.png";